import React, { lazy } from "react";
const HydrationLoadScript = lazy(
  () => import("@controls/HydrationLoadScripts.js"),
);
const GroupButtons = ({ children, noLine = 0, className = "" }) => {
  return (
    <div className={`dataEntryButtons ${className} ${noLine ? "noLines" : ""}`}>
      <HydrationLoadScript
        postEvt={() => {
          import("@css/dataEntryButtonsStyles.css");
        }}
      />
      {children}
    </div>
  );
};
export default GroupButtons;
